import { useEffect, useState, useRef } from "react";
import { Button, Dropdown, Menu } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import JDCreationForm from "../JDCreationForm";
import JDAssignmentForm from "../JDAssignmentForm";
import JDSummary from "../JDSummary";
import ExportTemplate from "../exportTemplate";
import AllEvaluations from "../AllEvaluations";
import Panel from "../Panels/Panels";
import useJDStore from "../../store/jd.store";
import useMembersStore from "../../store/members.store";

import "./createJd.scss";
import JDInterviews from "../JDInterviews";
import JDAvailableCandidates from "../JDAvailableCandidates";
import JDResumeStatus from "../JDResumeStatus";
import JDSelectionAndOnboarding from "../JDSelectionAndOnboarding";
import JDMatchingAutomation from "../JDMatchingAutmation";
import JDSkillMatrix from "../JDSkillMatrix";
import NuJobsReceivedApplications from "../qhrflowNuJobs/nuJobsReceivedApplications";
import JDEventCreationForm from "../JDEventCreationForm";

function CreateJD({nujobsPost=false}) {
  const navigate = useNavigate();
  const location = useLocation();
  const newView = location.state?.newView || "";
  const searchResumeID = location.state?.searchResumeID || "";
  const pathSegments = location.pathname.split("/");
  const parentPath = pathSegments[1];
  
  const [currentView, setCurrentView] = useState(newView?newView:"description"); 
  const { value,product } = useParams();

  const { getJdByID, selectedJD,updateJdStatus,resetJDRefreshFlag} = useJDStore(); 
  const { getVendors,  getTeamMembers, getAssignedMembers } = useMembersStore();
  const [currentjdStatus, setCurrentJDStatus] = useState(selectedJD?.JDProject.ReqStatus);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const scrollRef = useRef(null);

    useEffect(() => {
        
        const fetchData = async (value) => {
          try {
            getJdByID(value);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
    
        //console.log("CreateJD use effects",value,newView)
        if(value !== undefined){
            // do the async callls
            fetchData(value);
            //getJdByID(value);
            //needed for multi tenant systems
            getVendors();
            getTeamMembers();
            getAssignedMembers(value);
        }
        if (newView) {
            setCurrentView(newView);
        }
        window.scrollTo({ top: 0, behavior: "smooth" });        
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const checkScroll = () => {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    checkScroll();
    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  useEffect(() => {
    setCurrentJDStatus(selectedJD?.JDProject.ReqStatus);
    resetJDRefreshFlag();
  }, [selectedJD]);

  const scroll = (direction) => {
    const el = scrollRef.current;
    const scrollAmount = 200;
    if (direction === "left") el.scrollLeft -= scrollAmount;
    else el.scrollLeft += scrollAmount;
  };

  const currentProduct = product || "qhrflow";
  const isNuJobsPost = currentProduct === "nujobs";

  const view = isNuJobsPost || nujobsPost == true?{       
          description: JDCreationForm,
          assignment: JDAssignmentForm,
          summary: NuJobsReceivedApplications,
          jdevents:JDEventCreationForm
        }
        :
        {
          description: JDCreationForm,
          assignment: JDAssignmentForm,
          summary: JDSummary,
          availableCandidates: JDAvailableCandidates,
          resumeStatus:JDResumeStatus, 
          interview: JDInterviews,
          selectionAndOnboarding: JDSelectionAndOnboarding,
          skillMatrix: JDSkillMatrix,
          export: ExportTemplate,
          eval:AllEvaluations,
          panel : Panel,
          matchingAutomation: JDMatchingAutomation, 
          jdevents:JDEventCreationForm
    };
    
    const handleUpdateView = (view) => {
        setCurrentView(view)
    };

    const handleMenuClick = (e) => {
        console.log('Clicked on menu item:', e);
        if(value !== undefined){
            updateJdStatus(e.key,value)
        }
        setCurrentJDStatus(e.key,value) 
        setDropdownVisible(false)  
        // You can handle the menu item click event here
    };
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const menu = (
        <Menu onClick={handleMenuClick}>
            {/* Define menu items here */}
            <Menu.Item key="Active" >Active </Menu.Item>
            <Menu.Item key="Hold Pipeline" >Hold Pipeline</Menu.Item>
            <Menu.Item key="Hold Selection" >Hold Selection</Menu.Item>
            <Menu.Item key="Hold FB Pending" >Hold FB Pending</Menu.Item>
            <Menu.Item key="Closed" >Closed</Menu.Item>
        </Menu>
    );

  const CurrentView = view[currentView];

  return (
    <div className="create-jd-wrapper">
      {value ? (
        <div
          className="jd-primary-info-wrapper"
          style={{ textAlign: "center" }}
        >
          <div className="jd-primary-info">
            {selectedJD?.JDClient?.ClientName != "" ? (
              <>
                <div className="job-id-tag">
                  {selectedJD?.JDClient?.ClientName} &nbsp;&gt;&nbsp;{" "}
                  {selectedJD?.JDClient?.TaName} &nbsp; &gt;&nbsp;
                  <p
                    style={{
                      marginLeft: "20px",
                      marginTop: "15px",
                      fontWeight: "600",
                      fontSize: "14px",
                      color: "#000000",
                    }}
                  >
                    {selectedJD?.JDDetails.Title}
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="job-id-tag">
                  <p
                    style={{
                      marginLeft: "20px",
                      marginTop: "15px",
                      fontWeight: "600",
                      fontSize: "14px",
                      color: "#000000",
                    }}
                  >
                    {selectedJD?.JDDetails.Title}
                  </p>
                </div>
              </>
            )}
          </div>
          <div className="jd-primary-info">
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              visible={dropdownVisible}
              onVisibleChange={(visible) => setDropdownVisible(visible)}
            >
              <Button className="jd-primary-btn">
                <span style={{ color: "#008fff", textTransform: "uppercase" }}>
                  {" "}
                  {currentjdStatus}{" "}
                </span>{" "}
                {/* Display selected status */}
              </Button>
            </Dropdown>
          </div>
        </div>
      ) : null}
      <div className="jd-creation-form-options-wrapper">
        {value && (
          <div
            className="jd-form-arrow-btn"
            onClick={() => scroll("left")}
            style={{ color: !canScrollLeft && "lightgrey" }}
          >
            <LeftOutlined />
          </div>
        )}
        <div className="jd-creation-form-first-options-wrapper" ref={scrollRef}>
          {value ? (
            <>
              <Button
                onClick={() => {
                  setCurrentView("description");
                  //   navigate(`/jds/${value}`);
                }}
                type="primary"
                className={`jd-form-option-btn ${
                  currentView === "description" && "jd-form-option-btn-active"
                }`}
              >
                JD
              </Button>
              <Button
                onClick={() => {
                  setCurrentView("assignment");
                                }}
                                type="primary"
                                className={`jd-form-option-btn ${
                                    currentView === "assignment" &&
                                    "jd-form-option-btn-active"
                                }`}
                            >
                                Assignment
                            </Button>
                            <Button
                                onClick={() => setCurrentView("summary")}
                                type="primary"
                                className={`jd-form-option-btn ${
                                    currentView === "summary" &&
                                    "jd-form-option-btn-active"
                                }`}
                            >
                                Resumes
                            </Button>
                            {
                            isNuJobsPost?<>
                              <Button
                                  onClick={() => setCurrentView("jdevents")}
                                  type="primary"
                                  className={`jd-form-option-btn ${
                                      currentView === "jdevents" &&
                                      "jd-form-option-btn-active"
                                  }`}
                              >
                                  Events
                              </Button>                            
                            </>
                            :<>
                              <Button
                                  onClick={() => setCurrentView("availableCandidates")}
                                  type="primary"
                                  className={`jd-form-option-btn ${
                                      currentView === "availableCandidates" &&
                                      "jd-form-option-btn-active"
                                  }`}
                              >
                                  Available Candidates
                              </Button>
                              <Button
                                  onClick={() => setCurrentView("resumeStatus")}
                                  type="primary"
                                  className={`jd-form-option-btn ${
                                      currentView === "resumeStatus" &&
                                      "jd-form-option-btn-active"
                                  }`}
                              >
                                  Resume Status
                              </Button>                                                      
                              <Button
                                  onClick={() => setCurrentView("interview")}
                                  type="primary"
                                  className={`jd-form-option-btn ${
                                      currentView === "interview" &&
                                      "jd-form-option-btn-active"
                                  }`}
                              >
                                  Interviews
                              </Button> 
                              <Button
                                  onClick={() => setCurrentView("skillMatrix")}
                                  type="primary"
                                  className={`jd-form-option-btn ${
                                      currentView === "skillMatrix" &&
                                      "jd-form-option-btn-active"
                                  }`}
                              >
                                  Skill Matrix
                              </Button>                             
                              <Button
                                  onClick={() => setCurrentView("eval")}
                                  type="primary"
                                  className={`jd-form-option-btn ${
                                      currentView === "eval" &&
                                      "jd-form-option-btn-active"
                                  }`}
                              >
                                  Evaluations
                              </Button>                                                         
                              <Button
                                  onClick={() => setCurrentView("selectionAndOnboarding")}
                                  type="primary"
                                  className={`jd-form-option-btn ${
                                      currentView === "selectionAndOnboarding" &&
                                      "jd-form-option-btn-active"
                                  }`}
                              >
                                  Selection and Onboarding
                              </Button>                                                                                                               
                              <Button
                                  type="primary"
                                  className="jd-form-option-btn"
                                  onClick={() => setCurrentView("export")}
                              >
                                  Export Template
                              </Button>
                              <Button
                                  type="primary"
                                  className="jd-form-option-btn"
                                  onClick={() => setCurrentView("panel")}
                              >
                                  Panels
                              </Button>
                              <Button
                                  type="primary"
                                  className="jd-form-option-btn"
                                  onClick={() => setCurrentView("matchingAutomation")}
                              >
                                  Matching Automation
                              </Button>     
                              <Button
                                  onClick={() => setCurrentView("jdevents")}
                                  type="primary"
                                  className={`jd-form-option-btn ${
                                      currentView === "jdevents" &&
                                      "jd-form-option-btn-active"
                                  }`}
                              >
                                  Events
                              </Button>                                                         
                            </>
                            }                                                       
                        </>
                    ) : null}
                </div>
        {value && (
        <div
          className="jd-form-arrow-btn"
          onClick={() => scroll("right")}
          style={{ color: !canScrollRight && "lightgrey" }}
        >
          <RightOutlined />
        </div>
        )}
      </div>
      <CurrentView nujobsPost = {nujobsPost ||isNuJobsPost} setCurrentView={handleUpdateView} selectedJD={selectedJD} searchResume={searchResumeID}/>
    </div>
  );
}

export default CreateJD;
